// src/SettingsProvider.js
import React, { createContext, useContext } from 'react';

// Create the Settings Context
const SettingsContext = createContext();

// Custom hook to use the Settings Context
export const useSettings = () => {
  return useContext(SettingsContext);
};

// Provider component to pass settings throughout the app
export const SettingsProvider = ({ settings, children }) => {
  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
};
